// Tipos de actas
export const INICIO = 1;
export const CIERRE = 3;
